import Vue from 'vue'
import Url from '../../../static/apiurl.json'
import CripNotice from 'crip-vue-notice'
import api from '../../services/service_pos'
var numeral = require('numeral')
var moment = require('moment')
const ThaiBaht = require('thai-baht-text')
Vue.use(CripNotice)

Vue.mixin({
  data () {
    return {
      REST_URL: Url.api,
      PRINTER_HOST: Url.printer_url
    }
  },
  methods: {
    checkUser () {
      this.$store.state.currentPath = this.$route.path
      if (sessionStorage.user) {
        this.$store.state.token = sessionStorage.token
        this.$store.state.user = JSON.parse(sessionStorage.user)
        this.getConfig()
      } else {
        this.$router.push('/login')
      }
    },
    getConfig () {
      var body = {}
      api.configDetail(
        this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            sessionStorage.config = JSON.stringify(result.data)
            this.$store.state.config = result.data
            localStorage.setItem('config', JSON.stringify(result.data))
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getListHostDetail (data, afterSuccess) {
      sessionStorage.hostshift = undefined
      var body = { 'host_code': data.host_code }
      api.getHostShiftDetail(
        this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            sessionStorage.hostshift = JSON.stringify(result.data)
            this.$router.push('/pos')
            if (typeof afterSuccess === 'function') {
              afterSuccess()
            }
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    openCashBox (data) {
      var body = { 'host_code': data.host_code, 'printer_port': data.printer_port }
      api.openCashBox(
        this.REST_URL,
        body,
        this.header,
        result => {
          if (result.response === 'success') {
            this.alert_msg('success', 'แจ้งเตือนระบบ', 'เปิดกล่องเก็บเงินเรียบร้อย')
          } else {
            // this.alert_msg('warning', 'แจ้งเตือนระบบ', 'เปิดกล่องเก็บเงินไม่ได้')
          }
        },
        error => {
          console.log(error)
          this.openCashBox(data)
          // alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    doingNow () {
      this.alert_msg('warning', 'แจ้งเตือนระบบ', 'ระบบกำลังพัฒนา')
    },
    dateYearThai (date) {
      return moment(date).format('YYYY')
    },
    dateMonth (date) {
      return moment(date).format('YYYY-MM')
    },
    alert_msg (type, title, text) {
      this.$notice[type]({
        title: title,
        description: text
      })
    },
    dateFormat (date) {
      return moment(date).format('L')
    },
    dateTimeFormatDMY (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    dateTimeHHMMSS (date) {
      return moment(date).format('HH:mm:ss')
    },
    dateDMY (date) {
      return moment(date).format('YYYYMMDD')
    },
    dateFormatDMY (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    dateFormatDMY2 (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    dateFormatMY (date) {
      return moment(date).format('MM/YYYY')
    },
    monthFormat (str) {
      switch (str) {
        case '01':
          return 'ม.ค'
        case '02':
          return 'ก.พ'
        case '03':
          return 'มี.ค'
        case '04':
          return 'เม.ย'
        case '05':
          return 'พ.ค'
        case '06':
          return 'มิ.ย'
        case '07':
          return 'ก.ค'
        case '08':
          return 'ส.ค'
        case '09':
          return 'ก.ย'
        case '10':
          return 'ต.ค'
        case '11':
          return 'พ.ย'
        default:
          return 'ธ.ค'
      }
    },
    monthYearFormat (str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0]
        case '02':
          return 'กุมภาพันธ์ ' + date[0]
        case '03':
          return 'มีนาคม ' + date[0]
        case '04':
          return 'เมษายน ' + date[0]
        case '05':
          return 'พฤษภาคม ' + date[0]
        case '06':
          return 'มิถุนายน ' + date[0]
        case '07':
          return 'กรกฎาคม ' + date[0]
        case '08':
          return 'สิงหาคม ' + date[0]
        case '09':
          return 'กันยายน ' + date[0]
        case '10':
          return 'ตุลาคม ' + date[0]
        case '11':
          return 'พฤศจิกายน ' + date[0]
        default:
          return 'ธันวาคม ' + date[0]
      }
    },
    numberFormatThenZero (str) {
      if (parseFloat(str) > 0) {
        return numeral(str).format('0,0')
      } else {
        return numeral('0').format('0,0')
      }
    },
    numberFormat (str) {
      return numeral(str).format('0,0')
    },
    numberFormatDecimal (str) {
      return numeral(str).format('0,0.00')
    },
    moneyText (str) {
      return ThaiBaht(str)
    },
    convert_vs (val) {
      var data = []
      var len = 3
      if (val.length > 3) {
        len = val.length
      }
      var vallen = val.length
      for (var i = 0; i < len; i++) {
        var v = val.split('')
        if (len - i === vallen) {
          var ss = len - i
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val)
            } else {
              if (len > val.length) {
                data.push(v[i - 1])
              } else {
                data.push(v[i])
              }
            }
          } else {
            data.push(v[i - 1])
          }
          vallen--
        } else {
          data.push('0')
        }
      }
      var versions = ''
      for (var l = 0; l < data.length; l++) {
        versions += data[l]
        if (l < data.length - 1) {
          versions += '.'
        }
      }
      return versions
    },
    getParam (param) {
      var url = new URL(window.location.href)
      var c = url.searchParams.get(param)
      return c
    },
    convertTitleCalendar (str) {
      const date = str.split(' ')
      switch (date[0]) {
        case 'มกราคม':
          return '01-' + date[1]
        case 'กุมภาพันธ์':
          return '02-' + date[1]
        case 'มีนาคม':
          return '03-' + date[1]
        case 'เมษายน':
          return '04-' + date[1]
        case 'พฤษภาคม':
          return '05-' + date[1]
        case 'มิถุนายน':
          return '06-' + date[1]
        case 'กรกฎาคม':
          return '07-' + date[1]
        case 'สิงหาคม':
          return '08-' + date[1]
        case 'กันยายน':
          return '09-' + date[1]
        case 'ตุลาคม':
          return '10-' + date[1]
        case 'พฤศจิกายน':
          return '11-' + date[1]
        default:
          return '12-' + date[1]
      }
    },
    colorItemDefalt (val) {
      switch (val) {
        case 0:
          return 'white'
        case 1:
          return 'green'
        default:
          return 'white'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/mixin.js